document.addEventListener('DOMContentLoaded', function() {
  var galleries = document.querySelectorAll('.product-gallery:not(.product-gallery--init)');
  
  galleries.forEach(function(gallery) {
    gallery.classList.add('product-gallery--init');

    var swiperContainer = gallery.querySelector('.swiper-container');
    var swiperSlides = swiperContainer.querySelectorAll('.swiper-slide');

    // Vérifie s'il y a plusieurs slides
    if (swiperSlides.length > 1) {
      var initial = 0;
      var featuredSlide = swiperContainer.querySelector('.swiper-slide[data-featured="true"]');
      if (featuredSlide) {
        initial = Array.from(swiperSlides).indexOf(featuredSlide);
      }

      var galleryTop = new Swiper(swiperContainer, {
        navigation: {
          nextEl: swiperContainer.querySelector('.swiper-button-next'),
          prevEl: swiperContainer.querySelector('.swiper-button-prev')
        },
        slidesPerView: 1,
        speed: 500,
        initialSlide: initial,
        pagination: {
          el: swiperContainer.querySelector('.swiper-pagination'),
          clickable: true,
        }
      });

      galleryTop.slideTo(initial, 0);

      // Contrôle de la galerie
      gallery.addEventListener('click', function(e) {
        if (e.target.tagName === 'A') {
          e.preventDefault();
          var index = Array.from(gallery.querySelectorAll('a')).indexOf(e.target);
          galleryTop.slideTo(index);
        }
      });
    }
  });


  // lightbox on click
  $(document).on('click', '.product-gallery .gallery-top a', function(e){
    e.preventDefault();
    if($(this).closest('.quickbuy-form').length == 0) {
      var $gall = $(this).closest('.product-gallery');
      if($('.gallery-top .swiper-slide', $gall).length > 1) {
        var imgs = Array();
        var srcToShow = $(this).attr('href');
        var indexToShow = 0;
        $('.gallery-top .swiper-slide a', $gall).each(function(index){
          imgs.push({
            href: $(this).attr('href')
          });
          if($(this).attr('href') == srcToShow) {
            indexToShow = index;
          }
        });
        $.fancybox(imgs, { index: indexToShow, padding: 0 });
      } else {
        $.fancybox([{href: $(this).attr('href')}], { padding: 0 });
      }
    }
  });

  // Pour les custom-metafields
document.querySelectorAll('.custom-metafields .section-metafields').forEach(function(section) {
    const header = section.querySelector('h2');
    const content = header.nextElementSibling;
    console.log('header: ', header)
    console.log('content: ', content)

    if (header && content) {
      header.style.cursor = 'pointer';
      header.addEventListener('click', function () {
        if (content.style.display === 'none' || content.style.display === '') {
          content.style.display = 'block';
        } else {
          content.style.display = 'none';
        }
      });
    }
  });

// Gestion du modal
var modal = document.getElementById("guideDesTaillesModal");
var btn = document.getElementById("guideDesTaillesBtn");
var span = document.getElementsByClassName("close")[0];

// var detailsModal = document.getElementById("detailsModal")
// var detailsBtn = document.getElementById("detailsBtn")
// var detailsSpan = document.getElementsByClassName("close")[1];

var shippingModal = document.getElementById("shippingModal")
var shippingBtn = document.getElementById("shippingBtn")
var shippingSpan = document.getElementsByClassName("close")[1];

// Ouverture du modal
if (btn) {
  btn.onclick = function() {
    modal.style.display = "block";
  }
}

// if (detailsBtn) {
//   detailsBtn.onclick = function() {
//     console.log('---> details modal')
//     detailsModal.style.display = "block";
//   }
// }

if(shippingBtn){
  shippingBtn.onclick = function() {
    console.log('---> shippingModal modal')
    shippingModal.style.display = "block";
  }
}
  
// Fermeture du modal
if (span) {
  span.onclick = function() {
    modal.style.display = "none";
    detailsModal.style.display = "none";
  }
}

// if(detailsSpan){
//   detailsSpan.onclick = function() {
//     detailsModal.style.display = "none";
//   }
// }

if (shippingSpan) {
  shippingSpan.onclick = function() {
    modal.style.display = "none";
    shippingModal.style.display = "none";
  }
}

// Fermeture du modal en cliquant à l'extérieur
window.onclick = function(event) {
  if (modal && event.target == modal) {
    modal.style.display = "none";
  }
  // if (detailsModal && event.target == detailsModal) {
  //   detailsModal.style.display = "none";
  // }
  if (shippingModal && event.target == shippingModal) {
    shippingModal.style.display = "none";
  }
}
  
});






